module.exports = __webpack_public_path__ + "img/migrant_worker_urban_vietnam_binh_dang_fes (11).388a518f.jpg";